import React from 'react'
import PropTypes from 'prop-types'
import {Breadcrumb as ChakraBreadcrumb} from '@chakra-ui/react3'
import Link from '../../../components/link'

// helper to create an unstyled link as chakra passes the styles as __css prop to the link
const UnstyledLink = (props) => <Link {...props} variant="unstyled" size="unstyled" />

/**
 * Renders a breadcrumb item as a link, marking the current page when applicable.
 */
const BreadcrumbItem = ({
    children,
    href,
    isLastChild,
    // default to true when the item is the last child
    isCurrentPage = isLastChild,
    ...props
}) => {
    return (
        <ChakraBreadcrumb.Item {...props}>
            {href ? (
                <ChakraBreadcrumb.Link
                    as={UnstyledLink}
                    to={href}
                    aria-current={isCurrentPage ? 'page' : undefined}
                >
                    {children}
                </ChakraBreadcrumb.Link>
            ) : (
                <ChakraBreadcrumb.CurrentLink>{children}</ChakraBreadcrumb.CurrentLink>
            )}
        </ChakraBreadcrumb.Item>
    )
}

BreadcrumbItem.propTypes = {
    children: PropTypes.node,
    href: PropTypes.string,
    isCurrentPage: PropTypes.bool,
    isLastChild: PropTypes.bool
}

export default BreadcrumbItem
